import useBaseDataContext from '@context/useBaseDataContext';
import useMyRouting from '@context/useMyRouting/useMyRouting';
import { LinearProgress } from '@material-ui/core';
import Typography from '@mui/material/Typography';
import { ADDITIONAL_SERVICE_TYPE_CALCULATION, ROUTE_TYPE_CALCULATION } from '@pages/History/consts';
import {
  HistoryItemParamsState,
  HistoryRouteData,
  HistoryServicesData,
} from '@pages/History/types';
import { HistoryItem } from '@services/AuthService/query/loadUserQuery';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { HistoryItemStub } from '../HistoryItemStub';
import { RouteHistoryItem } from '../RouteHistoryItem';
import { ServiceHistoryItem } from '../ServiceHistoryItem';

/**
 * Пропсы компонента
 */
type HistoryItemContentProps = {
  historyItem: HistoryItem;
  paramsState: HistoryItemParamsState;
};

/**
 * Содержимое элемента истории по типу расчета
 */
export const HistoryItemContent = ({ historyItem, paramsState }: HistoryItemContentProps) => {
  const { t } = useTranslation(['OrderList']);
  const [settings] = useMyRouting().useSettings().useState();
  const { useBaseData } = useBaseDataContext();
  const [baseData] = useBaseData().useState();
  const { primaryLanguageId } = settings;

  if (paramsState.isLoading) {
    return <LinearProgress />;
  }

  if (paramsState.isError) {
    return (
      <div className={'order-product-component'}>
        <Typography variant={'h4'}>{t('OrderList:FailedLoadCalculationParams')}</Typography>
      </div>
    );
  }

  switch (historyItem.type_calculation) {
    case ROUTE_TYPE_CALCULATION:
      if (!baseData) {
        return <LinearProgress />;
      }

      return (
        <RouteHistoryItem
          data={paramsState.data as HistoryRouteData}
          baseData={baseData}
          langId={primaryLanguageId}
        />
      );
    case ADDITIONAL_SERVICE_TYPE_CALCULATION:
      return (
        <ServiceHistoryItem
          services={paramsState.data as HistoryServicesData}
          langId={primaryLanguageId}
        />
      );
    default:
      return <HistoryItemStub />;
  }
};
